import { render, staticRenderFns } from "./LogMovManifestacao.vue?vue&type=template&id=0fb2ab36&scoped=true&"
import script from "./LogMovManifestacao.vue?vue&type=script&lang=js&"
export * from "./LogMovManifestacao.vue?vue&type=script&lang=js&"
import style0 from "./LogMovManifestacao.vue?vue&type=style&index=0&id=0fb2ab36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2ab36",
  null
  
)

export default component.exports